import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-traceabilityList",
  "use": "icon-traceabilityList-usage",
  "viewBox": "0 0 113.39 113.39",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 113.39 113.39\" id=\"icon-traceabilityList\"><defs><style>#icon-traceabilityList .cls-1{fill:#bfcbd9;}</style></defs><title>溯源配置</title><path class=\"cls-1\" d=\"M71.61,56.69a15.09,15.09,0,1,1-8.19-13.25L107.48,5.9,69.94,50A14.83,14.83,0,0,1,71.61,56.69Zm-23.87,0a8.95,8.95,0,1,0,8.95-8.95A8.95,8.95,0,0,0,47.74,56.69ZM56.69,6a50.7,50.7,0,1,0,44.62,26.57l3.92-5A56.85,56.85,0,1,1,85.89,8.16l-5,3.92A50.49,50.49,0,0,0,56.69,6Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol